import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  #pointerStart
  #pointerEnd

  static targets = ['textarea', 'tagsList', 'controlsList']

  connect() {
    this.#bindAttributes()
  }

  updatePosition() {
    this.#pointerStart = this.textareaTarget.selectionStart
    this.#pointerEnd = this.textareaTarget.selectionEnd
  }

  #bindAttributes() {
    this.tagsListTarget.querySelectorAll('li').forEach(el => {
      el.addEventListener('click', _e => { this.#addTag(el.textContent) })
    })

    this.controlsListTarget.querySelectorAll('li').forEach(el => {
      el.addEventListener('click', _e => { this.#addControlTag(el.dataset.controlTag) })
    })
  }

  #addTag(text) {
    const currentText = this.textareaTarget.value
    const updatedText = `${currentText.slice(0, this.#pointerStart)} {{ ${text} }} ${currentText.slice(this.#pointerEnd)}`
    this.textareaTarget.value = updatedText
  }

  #addControlTag(control){
    const currentText = this.textareaTarget.value
    const updatedText = `${currentText.slice(0, this.#pointerStart)} [[ ${control} ]] ${currentText.slice(this.#pointerEnd)}`

    this.textareaTarget.value = updatedText
  }
}
